import { type ReactNode, createContext, useContext, useMemo } from 'react';

import { type RegionName } from '../nav';

interface RegionContextValue {
  regionName: RegionName;
}

const RegionNameContext = createContext<RegionContextValue>({
  regionName: 'root',
});

export function RegionNameProvider({
  regionName,
  children,
}: {
  regionName: RegionName;
  children?: ReactNode;
}) {
  const value = useMemo(
    () => ({
      regionName,
    }),
    [regionName],
  );
  return <RegionNameContext.Provider value={value}>{children}</RegionNameContext.Provider>;
}

export function useRegionNameContext() {
  return useContext(RegionNameContext);
}
